import { useEffect, useLayoutEffect } from 'react'

// https://eight-bites.blog/en/2021/05/uselayouteffect-ssr
export const getIsomorphicEffect = () => {
  return typeof window !== 'undefined' ? useLayoutEffect : useEffect
}
